import { asPage } from 'src/components/hoc/asPage'
import { EventTop } from 'src/compositions/Events'

export default asPage(EventTop, {
  pageTitle: '『ONLYSTORY』会員様限定イベント',
})
